import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { build, pool } from '../../../../../common/classes/request-builder';
import { ReactiveFormChangedField, ReactiveFormValue } from '@fitogest/reactive-form-builder/interfaces';
import { BaseForm } from '../../../../base-form';
import { DashboardService } from '../../../../../service/events/dashboard.service';
import { FincasApiService } from '../../../../../service/api/fincas-api.service';
import { TareasApiService } from '../../../../../service/api/tareas-api.service';
import { SubcontratoModel } from '../../../../../models/tareas/subcontrato.model';
import { SubcontratosFormDefinition } from './form-control/form-definition';

@Component({
    selector: 'app-subcontratos-form',
    standalone: false,
    templateUrl: './subcontratos-form.component.html',
    styleUrls: ['./subcontratos-form.component.css']
})
export class SubcontratosFormComponent extends BaseForm<SubcontratoModel> implements OnInit {
    public form!: SubcontratosFormDefinition;
    public formReady = false;
    public loadingData = true;

    constructor(
        public override route: ActivatedRoute,
        public override dashboard: DashboardService,
        public fincasApi: FincasApiService,
        public tareasApi: TareasApiService,
        public override router: Router,
    ) {
        super(
            route,
            router,
            dashboard,
            tareasApi.subcontratos.PUT,
            tareasApi.subcontratos.POST,
            'subcontratos',
            'Actualizar Subcontratos',
            'Realizar Subcontratos',
            'Duplicar Subcontratos'
        );
    }

    public ngOnInit(): void {
        this.softInit(this.getType());
        void this.setupForm();
    }

    public formChanges(
        formModel: ReactiveFormValue<SubcontratoModel>,
        lastChangedFieldName: ReactiveFormChangedField<SubcontratoModel>,
    ): void {
        this.form.model = {
            ...this.form.model,
            ...formModel,
        };

        if (String(lastChangedFieldName) === 'id_finca') {
            this.dropdownLoadTrigger.next();
        }
    }

    private async setupForm(): Promise<void> {
        this.model = this.getModel();
        this.form = new SubcontratosFormDefinition(this.getType(), this.model);

        await this.initFormData();
        this.formReady = true;
    }

    private async initFormData(): Promise<boolean> {
        this.loadingData = true;
        this.resetExternalDropdowns();

        return pool([
            build(this.fincasApi.fincasGET, this.form.lists.fincas, 'nombre', false),
        ], () => this.dropdownLoadTrigger.next())
            .then(() => {
                this.applyCreationDefaults();
                this.loadingData = false;
                this.finalizeExternalDropdowns();
                this.dropdownLoadTrigger.next();

                return true;
            })
            .catch((error: unknown) => {
                this.loadingData = false;
                this.finalizeExternalDropdowns();
                this.dropdownLoadTrigger.next();
                console.error('Error loading subcontratos form data.', error);

                return true;
            });
    }

    private applyCreationDefaults(): void {
        if (!this.form.model.id_finca && this.form.lists.fincas.values.length > 0) {
            this.form.model.id_finca = this.form.lists.fincas.values[0]?.value?.id ?? null;
        }
    }
}
